import { Popup } from "devextreme-react/popup";

interface IAgreement {
    agreement: boolean,
    setAgreement: any
}

const Aggrement = ({ agreement, setAgreement }: IAgreement) => {


    return (
        <>
            <Popup
                visible={!agreement}
                //onHiding={() => { clearFieldsAddBuilding(); setBuilidingPopupVisible(false); setEditBuildingFlag(false); }}
                dragEnabled={true}
                deferRendering={true}
                closeOnOutsideClick={false}
                showCloseButton={false}
                showTitle={true}
                title={"Zgoda"}
                container=".dx-viewport"
                width="60%"
                height="90%"
            >

                <div className="registerRegulation">
                    <>
                    <div style={{ width: '100%', alignItems: 'center', fontWeight: 'bold' }}>INFORMACJE DOTYCZĄCE PRZETWARZANIA TWOICH DANYCH OSOBOWYCH</div>
                        Niniejszą informację otrzymałeś w związku z obowiązkami określonymi w art. 13 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dziennik Urzędowy Unii Europejskiej z dnia 4 maja 2016 r. L 119/1). 
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Administrator danych</div>
                        Administratorem Pani/Pana danych osobowych jest Prezydent Wrocławia. Można się z nami skontaktować w następujący sposób:
                        <br/>- listownie na adres: Prezydent Wrocławia, Urząd Miejski
                        Wrocławia, pl. Nowy Targ 1-8, 50-141 Wrocław, 
                        <br/>- przez e-mail: wpo@um.wroc.pl, 
                        <br/>- telefonicznie: 71 777 81 39.
                        
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Cele przetwarzania danych</div>
                        Będziemy przetwarzać Pani/Pana dane osobowe w celu realizacji zadań związanych z ustalaniem i określaniem wysokości opłaty za gospodarowanie odpadami komunalnymi, jej poborem i windykacją oraz w celach kontaktowych. Numer telefonu oraz adres e-mail będziemy przetwarzać w celu wysyłania powiadomień, jeżeli wyrazisz na to wyraźną zgodę.

                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}> Podstawy prawne przetwarzania</div>
                        Będziemy przetwarzać Pani/Pana dane osobowe, ponieważ jest to niezbędne do wypełnienia obowiązku prawnego, który ciąży na nas i wynika z:
                        <br/>– ustawy z dnia 29 sierpnia 1997 r. Ordynacja podatkowa, 
                        <br/>- ustawy z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego,
                        <br/>-  ustawy z dnia 13 września 1996 r. o utrzymaniu czystości i porządku w gminach,
                        <br/>- ustawy z dnia 17 czerwca 1966 r. o postępowaniu egzekucyjnym w administracji, 
                        <br/>– ustawy z dnia 16 listopada 2006 r. o opłacie skarbowej,
                        <br/>- ustawy z dnia 23 kwietnia 1964 r. Kodeks cywilny, 
                        <br/>– ustawy z dnia 17 maja 1989 r. Prawo geodezyjne i kartograficzne, 
                        <br/>– ustawy z dnia 6 lipca 1982 r. o księgach wieczystych i hipotece,
                        <br/>- ustawy z dnia 18 listopada 2020 r. o doręczeniach elektronicznych,
                        <br/>– ustawy z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów realizujących zadania publiczne.
                        <br/>Będziemy przetwarzać Pani/Pana dane osobowe na podstawie Pani/Pana wyraźnej zgody, którą można wycofać w dowolnym momencie.
                        
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Okres przechowywania danych	</div>
                        Będziemy przetwarzać Pani/Pana dane do czasu załatwienia Pani/Pana sprawy, a następnie przez 5 lat, licząc od stycznia kolejnego roku po jej zakończeniu.
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}> Odbiorcy danych</div>
                        Będziemy przekazywać Twoje dane osobowe:
                        <br/>- naszym dostawcom, którym zlecimy usługi związane z przetwarzaniem danych osobowych, np. dostawcom usług IT. Takie podmioty przetwarzają dane na podstawie umowy z nami                    i tylko zgodnie z naszymi poleceniami,
                        <br/>- upoważnionym podmiotom przetwarzającym dane osobowe na podstawie przepisów prawa.

                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Prawa związane z przetwarzaniem danych osobowych</div>
                        Przysługują Pani/Panu następujące prawa związane z przetwarzaniem danych osobowych:
                        <br/>- prawo dostępu do Pani/Pana danych osobowych,
                        <br/>- prawo żądania sprostowania i uzupełnienia niekompletnych Pani/Pana danych osobowych,
                        <br/>- prawo żądania ograniczenia przetwarzania Pani/Pana danych osobowych,
                        Aby skorzystać z powyższych praw, musi Pani/Pan skontaktować się z Administratorem danych (dane kontaktowe powyżej) lub Inspektorem Ochrony Danych (dane kontaktowe poniżej).
                        
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}> Inspektor Ochrony Danych </div>
                        W Urzędzie wyznaczony został Inspektor Ochrony Danych –  Sebastian Sobecki. Jest to osoba, z którą można się kontaktować w sprawach dotyczących przetwarzania Twoich danych osobowych oraz korzystania z przysługujących Ci praw związanych z przetwarzaniem danych.
                        Z Inspektorem można kontaktować się w następujący sposób:
                        <br/>- listownie na adres: ul. G. Zapolskiej 4, 50-032 Wrocław
                        <br/>- przez e-mail: iod@um.wroc.pl
                        <br/>- telefonicznie: 71 777 77 24

                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}> Prawo wniesienia skargi do organu</div>
                        Przysługuje Pani/Panu także prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych, tj. Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa.

                    </>
                </div>
                <div className="container p-3">
                    <div className="row">
                        <div className="d-flex justify-content-around">
                            <button

                                className="btnNext"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setAgreement(null)
                                }}
                            >
                                Nie wyrażam Zgody
                            </button>
                            <button
                                className="btnNext"
                                //style={{ backgroundColor: "#3cb371", &:hover: { textDecoration: 'underline', },      }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setAgreement(true)
                                }}>
                                Wyrażam Zgodę
                            </button>
                        </div>
                    </div>
                </div>

            </Popup>
        </>
    )
}

export default Aggrement